module.exports = __webpack_public_path__ + "static/Pod Foods-f748295454037ffa0baae519ea20f4fb.jpg";